<template>
  <svg viewBox="0 0 16 14"><path fill-rule="nonzero" d="M9.196.147L9.28.22l6 6a.754.754 0 01.092.11l.054.095.035.086.027.103.01.084v.103l-.018.12-.019.068-.023.06-.035.07-.06.09-.063.071-6 6a.75.75 0 01-1.133-.976l.073-.084 4.718-4.72H.75a.75.75 0 01-.102-1.493L.75 6h12.189l-4.72-4.72A.75.75 0 019.095.083l.102.064z" /></svg>
</template>

<script>
export default {
  name: 'ArrowRight'
}
</script>
